// The calendar runs in FullCalendar's 'UTC' zone with offset-less times from
// the server, so a Date's UTC fields are the wall clock the user clicked.

// A Month-view day has no time of its own, so a new event starts at 9am.
export const ALL_DAY_START_HOUR = 9;
const ONE_HOUR_MS = 60 * 60 * 1000;

export function toWallClock(date: Date): string {
  return date.toISOString().slice(0, 16);
}

function withQuery(base: string, params: URLSearchParams): string {
  return `${base}${base.includes('?') ? '&' : '?'}${params.toString()}`;
}

export function newEventUrl(base: string, clicked: Date, allDay: boolean): string {
  const start = new Date(clicked.getTime());
  if (allDay) start.setUTCHours(ALL_DAY_START_HOUR, 0, 0, 0);
  const end = new Date(start.getTime() + ONE_HOUR_MS);

  return withQuery(
    base,
    new URLSearchParams({ start_datetime: toWallClock(start), end_datetime: toWallClock(end) }),
  );
}

export function eventsUrl(base: string, start: Date, end: Date, filters: string): string {
  return withQuery(
    base,
    new URLSearchParams({
      start: start.toISOString(),
      end: end.toISOString(),
      event_filters: filters,
    }),
  );
}

export function previewUrl(template: string, eventId: string): string {
  return template.replace('EVENT_ID', encodeURIComponent(eventId));
}
